var _path, _rect, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.0004 4.78711L26.7075 4.08L26.0004 3.37289L25.2933 4.08L26.0004 4.78711ZM46.5065 26.7074L47.2136 27.4145L48.6278 26.0003L47.9207 25.2932L46.5065 26.7074ZM26.0004 47.2135L25.2933 47.9206L25.9995 48.6269L26.7066 47.9215L26.0004 47.2135ZM4.78722 26.0003L4.08011 25.2932L3.373 26.0003L4.08011 26.7074L4.78722 26.0003ZM25.2933 5.49422L46.5065 26.7074L47.9207 25.2932L26.7075 4.08L25.2933 5.49422ZM26.7075 46.5064L5.49432 25.2932L4.08011 26.7074L25.2933 47.9206L26.7075 46.5064ZM5.49432 26.7074L26.7075 5.49422L25.2933 4.08L4.08011 25.2932L5.49432 26.7074ZM44.4705 27.3766L25.2942 46.5055L26.7066 47.9215L45.883 28.7926L44.4705 27.3766Z",
    fill: "#CCCCCC"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 27,
    y: 26.2783,
    width: 2,
    height: 10,
    transform: "rotate(180 27 26.2783)",
    fill: "#CCCCCC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 27.25,
    y: 30.7783,
    width: 2.5,
    height: 2.5,
    transform: "rotate(180 27.25 30.7783)",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.2e8cd258f63f2d7ea0360a97c5dbc2c0.svg";
export { ForwardRef as ReactComponent };